export const orderSubmitted = {
    thank_you_for_ordering: 'Thank you for ordering with us today!',
    waiting_time: 'Your Order will be ready in approx',
    minutes: 'Minutes',
    order_number: 'Your order number is %order_number'
}